import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { OpeneningList } from "../../../../ui/DataEntry/Select/OpeneningList";
import { useCarBrandsRequests } from "../../../../hooks/carSelection/useCarBrandsRequests";
import { CarCatalogOptionsItem } from "../../../../types/Car/CarCatalogOptionsItem.interface";
import { useNextStepRequest } from "../../../../hooks/carSelection/useNextStepRequest";
import { CarCatalogItem } from "../../../../types/Car/CarCatalogItem.interface";
import { useDispatch } from "react-redux";
import { selectCar } from "../../../../utils/storage/slices/userSlice";
import axios from "axios";
import { API_URL } from "../../../../config.tsx";

/**
 * Выбор автомобиля по атрибутам
 * @returns
 */
export const SelectCarByAttributes = () => {
    const [selectedBrand, setSelectedBrand] = useState<CarCatalogOptionsItem>({ id: '', value: 'Марка' });
    const [ssd, setSsd] = useState<string>('');
    const [isConfirm, setIsConfirm] = useState(false);
    const dispatch = useDispatch();

    // Запросы на получение данных
    const [brands, isLoadingBrands, setIsLoadingBrands]: [CarCatalogOptionsItem[], boolean, Dispatch<SetStateAction<boolean>>] = useCarBrandsRequests();
    const [catalogs, isLoadingCatalogs]: [CarCatalogItem[], boolean] = useNextStepRequest(selectedBrand.id, setIsLoadingBrands, ssd);

    // Установка состояния подтверждения выбора автомобиля
    useEffect(() => {
        setIsConfirm(catalogs.every(catalog => catalog.value !== ''));
    }, [catalogs]);

    /** Выбор марки */
    const selectBrand = (data: CarCatalogOptionsItem) => {
        setSelectedBrand(data);
        setSsd('');
    };

    /**
     * Выбор значения каталога
     * @param data - значение каталога
     * @param currentCatalog - текущий каталог
     */
    const selectCatalogValue = (data: CarCatalogOptionsItem) => {
        setSsd(data.id);
    };

    /** Обработчик подтверждения выбора автомобиля */
    const handleConfirm = () => {
        const MODELS_CATALOG_NAMES = ['Модель', 'Серия', 'Семейство', 'Model', 'Vehicle Family', 'Vehicle Name', 'Торговое обозначение'];
        const YEARS_CATALOG_NAMES = ['Год', 'Год выпуска', 'Year', 'Модельный год'];
        const BODIES_CATALOG_NAMES = ['Кузов', 'Body', 'Тип кузова'];
        const ENGINES_CATALOG_NAMES = ['Двигатель', 'Engine', 'Двигатель', 'Двигатель'];

        const car = {
            brandId: selectedBrand.id,
            ssd: ssd,
            brand: selectedBrand.value,
            model: catalogs.find(catalog => MODELS_CATALOG_NAMES.includes(catalog.name))?.value || '',
            year: catalogs.find(catalog => YEARS_CATALOG_NAMES.includes(catalog.name))?.value || '',
            body: catalogs.find(catalog => BODIES_CATALOG_NAMES.includes(catalog.name))?.value || '',
            engine: catalogs.find(catalog => ENGINES_CATALOG_NAMES.includes(catalog.name))?.value || '',
        };

        let domain = window?.location.origin || API_URL
        axios.get(`${domain}/find_vehicles_by_catalog?catalog=${selectedBrand.id}&ssd=${ssd}`, {
            withCredentials: true,
        })
            .then(result => result.data)
            .then(data => {
                car.ssd = data[0].data[0].ssd;
            })
            .catch(err => {
                console.error(err);
            })
            .finally(() => {
                dispatch(selectCar(car));
            });
    };

    return (
        <div className="flex-2 flex flex-col w-full">
            <p className="text-sm mb-3 text-gray-600 font-medium">Подбор по модели</p>
            <div className="flex flex-wrap gap-2 w-full">
                <OpeneningList currentItem={selectedBrand} setCurrentItem={selectBrand} list={brands} isLoading={isLoadingBrands} />
                {catalogs.map((catalog, index) =>
                    <OpeneningList key={`car-catalog-${index}`}
                        currentItem={{ id: ssd, value: catalog.value || catalog.name }}
                        setCurrentItem={selectCatalogValue}
                        disabled={catalog.options.length < 2}
                        list={catalog.options}
                        isLoading={isLoadingCatalogs} />)}
            </div>
            <button disabled={!isConfirm} className="mt-2 text-center sm:w-32 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 h-10 bg-orange-500 hover:bg-orange-600 text-white px-6"
                onClick={handleConfirm}>
                Подтвердить выбор
            </button>
        </div>
    );
};
